



import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import {
  ContentPriceSubjectTypeEnum,
  InputContentPriceUpdate,
} from "@scrile/api-provider/dist/api/ContentPriceProvider";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { InputContentSubscriptionLevelUpdate } from "@scrile/api-provider/dist/api/ContentSubscriptionLevelProvider";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import useMySubscriptionLevels from "@/hooks/useMySubscriptionLevels";
import providers from "@/lib/api";

export default defineComponent({
  name: "MediaPostPriceSettings",
  props: {
    postData: { type: Object as PropType<ContentSet>, required: true },
  },
  setup(props, { emit }) {
    const { authUserStrict, authorities } = useAuthUser();
    const { mySubscriptionLevels, getMySubscriptionLevels } = useMySubscriptionLevels();
    const priceList = ref<SubscriptionLevel[]>([]);
    const levelId = ref("0");
    const packageId = "0";
    const isPostOwner = computed(() => props.postData.userId === authUserStrict.value.id);

    const requiredAuthorities = computed(() => {
      return isPostOwner.value
        ? ["updateMyContentPrice", "updateMyContentSubscriptionLevel"]
        : ["updateAnyContentPrice", "updateAnyContentSubscriptionLevel"];
    });

    const allowUpdate = computed(() => checkAuthorities(authorities.value, requiredAuthorities.value));

    const updatePriceData = async () => {
      if (!allowUpdate.value) return;
      const priceUpdate: InputContentPriceUpdate = {
        packageId,
        subject: {
          subjectType: ContentPriceSubjectTypeEnum.CONTENT_SET,
          subjectId: props.postData.id,
        },
      };
      const levelUpdate: InputContentSubscriptionLevelUpdate = {
        levelId: levelId.value,
        subject: {
          subjectType: ContentPriceSubjectTypeEnum.CONTENT_SET,
          subjectId: props.postData.id,
        },
      };
      await Promise.all([
        providers.ContentPriceProvider.update({ data: priceUpdate }),
        providers.ContentSubscriptionLevelProvider.update({ data: levelUpdate }),
      ]);
    };

    const sendPriceEvent = () => {
      emit("priceChanged", {
        recurringLevel: priceList.value.find(i => i.id === levelId.value) || null,
        oneTimePackage: null,
      });
    };

    const getSubscriptionLevels = async () => {
      if (isPostOwner.value) {
        await getMySubscriptionLevels();
        priceList.value = mySubscriptionLevels.value ?? [];
      } else {
        priceList.value = await providers.SubscriptionLevelProvider.find({ userIds: [props.postData.userId] });
      }
    };

    const getData = async () => {
      if (!allowUpdate.value) return;
      await getSubscriptionLevels();
      const firstLevel = priceList.value[0];
      levelId.value = firstLevel ? firstLevel.id : "0";
      sendPriceEvent();
    };
    getData();

    emit("setUpdateCb", updatePriceData);

    return {};
  },
});
